<template>
  <div>
    <slot/>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'ScrollContent',
  mounted () {
    let contentWidth = 0

    this.timer = window.setInterval(() => {
      const width = this.$el.offsetWidth

      if (contentWidth !== width) {
        contentWidth = width
        store.commit('setResizeTimestamp', new Date().getTime())
      }
    }, 100)
  },
  destroyed () {
    window.clearInterval(this.timer)
  }
}
</script>

<style>

</style>
